import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CloseCrossIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 10, height = 10, stroke = "#62748C", ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9 1L1 9M1 1L9 9"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
